import { Network } from '@capacitor/network';

export class BaseService {
    
    checkNetworkError(response:any) {
        if(!response.status){
            //Network Error
            throw "Internal Network Error. Please try after sometime.";
        }
    }

    async currentNetworkStatus() {
        const status = await Network.getStatus();
        return status;
    }
}